import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import type SdDialog from '@solid-design-system/components/dist-versioned/components/dialog/dialog';
import { Dialog } from '../util/dialog';

/**
 * Automaticly closes a {@link Dialog} after `<sd-dialog>` was hidden.
 */
@Directive({
  selector: 'sd-4-5-1-dialog[wctSdDialogDestroyComponentAfterClose]',
  standalone: true,
})
export class SdDialogDestroyAfterCloseDirective {
  @Input({ required: true, alias: 'wctSdDialogDestroyComponentAfterClose' }) public dialog!: Dialog;

  private readonly elementRef: ElementRef<SdDialog> = inject(ElementRef);

  @HostListener('sd-after-hide', ['$event'])
  protected handleAfterHide(event: Event): void {
    if (event?.target !== this.elementRef.nativeElement) {
      return;
    }

    this.dialog.close();
  }
}
